/* eslint-disable jsx-a11y/anchor-is-valid */
import moment from 'moment'
import {enqueueSnackbar} from 'notistack'
import {FC, useEffect, useState} from 'react'
import {Column} from 'react-table'
import Swal from 'sweetalert2'
import {KTCard, KTSVG} from '../../../../../../../../_metronic/helpers'
import {KTable, KTableHeader, KTableLoading} from '../../../../../../components/UI'
import ButtonClose from '../../../../../../components/UI/Button/IconButton'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {useHoteleria} from '../../../../../../hooks/useHoteleria'
import {TabModel} from '../../../../../../models'
import {BookingDetailUpload} from '../../../../models/booking.model'
import {
  getListBulkLoadTrayService,
  reserveChangeService,
} from '../../../../services/booking.service'
import {ModalDetailBooking} from '../Modals/ModalDetailBooking'
import {getSnackBarToast} from '../../../../../../util/snackBar'

const getSnackBar = (message: string, variant: boolean) => {
  enqueueSnackbar(message, {
    variant: variant ? 'success' : 'error',
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right',
    },
  })
}

const TableUploadBookingDetails: FC = () => {
  const {data, setData, setPagination, loading, setLoading, pagination, clearSelected} = useKTable()
  const [showModal, setShowModal] = useState(false)
  const [bookingtoShow, setBookingToShow] = useState<BookingDetailUpload | any>(null)
  const {currentTabItem} = useHoteleria()
  // const dataDetail =
  //   data.some((item) => item.ReservaId && item.EstadoReserva_descripcion === 'Pendiente') || false

  const getUploadBookings = async () => {
    try {
      setLoading(true)
      const {data: response} = await getListBulkLoadTrayService({
        TipoBandeja: 'RES',
        pageNumber: pagination.currentPage,
        size: pagination.perPage,
      })
      if (!response.error) {
        setData(response.data)
        setPagination({
          ...pagination,
          totalResults: response.total,
        })
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  useEffect(() => {
    getUploadBookings()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage])

  useEffect(() => {
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  const handleShowDetail = (item: BookingDetailUpload) => {
    setBookingToShow(item)
    setShowModal(true)
  }

  const handleActionRow = async (item: BookingDetailUpload) => {
    // await new Promise((resolve) => setTimeout(resolve, 2000))
    // debugger
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'De asignar esta reserva?',
      //showDenyButton: true,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, asignar',
      confirmButtonColor: 'var(--kt-success)',
      //denyButtonText: `Don't save`,
      cancelButtonText: 'Rechazar',
      cancelButtonColor: 'var(--kt-primary)',
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
    }).then(async (result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        const data = await reserveChangeService({AceptarReserva: true, ReservaId: item.ReservaId})
        if (!data.data.error) {
          clearSelected()
          getUploadBookings()
          getSnackBarToast('Se asignó con éxito', 'success')
        } else {
          getSnackBarToast('Error interno, volver a intentarlo', 'error')
        }
      } else if (result.isDenied) {
        //Swal.fire('Changes are not saved', '', 'info')
      }
    })
  }

  const columns: Column<BookingDetailUpload>[] = [
    // {
    //   Header: (props) => <KTableHeader tableProps={props} showSelect={dataDetail} />,
    //   id: 'selection',
    //   Cell: ({...props}) =>
    //     props.row.original.ReservaId &&
    //     props.row.original.EstadoReserva_descripcion === 'Pendiente' ? (
    //       <KTableSelectionCell id={props.data[props.row.index].Id} />
    //     ) : (
    //       <></>
    //     ),
    // },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Archivo' />,
      accessor: 'NombreArchivo',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Tipo de Bandeja' />,
      accessor: 'TipoBandeja',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Reserva' />,
      accessor: 'NroReserva',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Registros cargados' />,
      accessor: 'RegistrosProcesados',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Registros aceptados' />,
      accessor: 'RegistrosAceptados',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Registros rechazados' />,
      accessor: 'RegistrosRechazados',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Fecha de carga' />,
      accessor: 'FechaHoraCarga',
      Cell: ({...props}) => (
        <div>{moment(props.row.original.FechaHoraCarga).local().format('DD/MM/YYYY HH:mm:ss')}</div>
      ),
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Acciones' />,
      id: 'actions',
      Cell: ({...props}) =>
        props.row.original.ReservaId &&
        props.row.original.EstadoReserva_descripcion?.toUpperCase() === 'PENDIENTE' ? (
          <button
            type='button'
            className='btn btn-success'
            onClick={() => handleActionRow(props.row.original)}
          >
            Asignar Reserva
          </button>
        ) : (
          <></>
        ),
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Ver' />,
      id: 'actions_ver',
      Cell: ({...props}) => (
        <div
          className='d-flex justify-content-center flex-shrink-0'
          onClick={() => handleShowDetail(props.row.original)}
        >
          <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
            <KTSVG path='/media/icons/duotune/general/gen004.svg' className='svg-icon-3' />
          </a>
        </div>
      ),
    },
  ]

  useEffect(() => {
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  useEffect(() => {
    if (currentTabItem.trayUpdated) {
      clearSelected()
      getUploadBookings()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTabItem.trayUpdated])

  // const handleAssign = () => {
  //   const filteredData =
  //     data
  //       ?.filter(
  //         (item) =>
  //           selected.includes(item.Id) &&
  //           item.ReservaId &&
  //           item.EstadoReserva_descripcion === 'Pendiente',
  //       )
  //       ?.map((item) => item.Id) || []
  // }

  return (
    <>
      <KTCard shadow className='m-5'>
        {/* <Button
          label='Asignar'
          onClick={handleAssign}
          classNameProp='ms-8 w-100px mt-2 mb-2'
          disabled={selected?.length < 1}
        /> */}
        <KTable data={data} columns={columns} />
        {loading ? <KTableLoading title='Cargando...' /> : null}
        <ModalDetailBooking
          show={showModal}
          setShow={setShowModal}
          bookingToShow={bookingtoShow}
          title='Detalle de Reserva Masiva Resumida'
        />
      </KTCard>
    </>
  )
}

const TableUploadBookingSummaryDetailsWrapper = () => {
  const {currentTabItem, changeCurrentTabItem} = useHoteleria()
  const handleBack = () => {
    const obj: TabModel = {
      ...currentTabItem,
      showPanel: false,
    }
    changeCurrentTabItem(obj)
  }
  //   let isDisabled = currentTabItem.idToEdit ? true : false
  return (
    <KTableProvider>
      <ButtonClose onClick={handleBack} color='#283897' />
      <TableUploadBookingDetails />
    </KTableProvider>
  )
}

export {TableUploadBookingSummaryDetailsWrapper}
